<template>
    <!-- app -->
    <div id="ModalLogin" class="client-login-modal">
        <modal v-if="showModal" @close="showModal = false">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrap">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <div class="row">
                                        <div class="col-xs-2">
                                            <img class="modal-logo" v-bind:src="templateDirectory + '/images/' + logo">
                                        </div>
                                        <div class="col-xs-8">
                                            <h3 class="modal-headline">LogIn</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <slot name="body">
                                        <div class="login-section">
                                            <div class="login-form-row input-row email-login-row">
                                                <span class="login-form-field-icon login-icon"></span>
                                                <input id="email-login" type="text" v-model="email" name="email" placeholder="Login" />
                                            </div>
                                            <div class="login-form-row input-row password-login-row">
                                                <span class="login-form-field-icon password-icon"></span>
                                                <input id="password-login" type="password" v-model="password" name="password" placeholder="Password" />
                                            </div>
                                            <div class="login-form-row links-row text-right">
                                                <a v-bind:href="forgot_pass_url" target="_blank">Forgot password?</a>
                                            </div>
                                            <div class="row login-form-row">
                                                <div id="rms-login-modal-messages" class="col-sm-12"></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12 text-center">
                                                    <input @click="loginAppUser" type="button" id="rms-login-button" class="login-button" name="login" value="Login">
                                                </div>
                                            </div>
                                        </div>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </modal>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {eventBus} from "../main"

    export default {
        name: 'ModalLogin',
        data() {
            return {
                admin_url: document.getElementById('admin_url').value,
                stylist_alias: document.getElementById('stylist_alias').value,
                forgot_pass_url: barber_page == 'true' ? 'https://book.ringmybarber.com/admin/forgot-password' : 'https://book.ringmystylist.com/admin/forgot-password',
            }
        },
        props: {
            logo: String,
            templateDirectory: String,
            showModal: String
        },
        created () {
            this.logo = this.$props.logo
            this.templateDirectory = this.$props.templateDirectory
        },
        methods: {
            closeModal() {
                this.showModal = false;
                eventBus.$emit('updateShowModalState',false);
            },
            loginAppUser(e) {
                var data = new FormData();
                data.append('action', 'login_app_user');
                data.append('email', this.email);
                data.append('password', this.password);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            $('#rms-login-modal-messages').html('<div class="alert alert-danger">There is an error</div>');
                        } else {
                            if(response.data.error==true) {
                                $('#rms-login-modal-messages').html('<div class="alert alert-danger">'+response.data.message+'</div>');
                            } else {
                                $('#rms-login-modal-messages').html('<div class="alert alert-success">'+response.data.message+'</div>');
                                eventBus.$emit('userLoggedIn',false);

                                setTimeout(()=>{
                                    this.closeModal();
                                }, 500);
                            }
                        }
                    });
                e.preventDefault();
            },
        }
    }
</script>

<style type="text/css">
    .client-login-modal .input-row,
    .client-login-modal .line-sep,
    .client-login-modal .login-form-row.links-row {
        margin-left: auto;
        margin-right: auto;
    }
</style>